import DatePicker from 'react-datepicker';

const DateRangePicker = ({
  id,
  dateRange,
  setDateRange,
  isClearable = true,
}) => {
  const [startDate, endDate] = dateRange;

  return (
    <DatePicker
      id={id}
      selectsRange
      startDate={startDate}
      endDate={endDate}
      onChange={(update) => {
        setDateRange(update);
      }}
      isClearable={isClearable}
      dateFormat="yyyy/MM/dd"
    />
  );
};

export default DateRangePicker;
